import type { MenuItem } from "../../../core/schema/MenuItem.js";

export function isMenuActive(menuItem: MenuItem, pageSlug: string): boolean {
	if ("href" in menuItem && pageSlug === menuItem.href) {
		return true;
	}

	return "submenus" in menuItem && menuItem.submenus.some((menuItem) => isMenuActive(menuItem, pageSlug));
}
